import type { MarketplaceOrder } from '../types/marketplace'

export const providerProfile = {
  handle: 'amarachi',
  displayName: 'Amarachi Obi',
  headline: 'Engineering mathematics tutoring and study planning',
  category: 'Academic support',
  subcategory: 'Tutoring',
  identityVerified: true,
  rating: 4.8,
  reviewCount: 27,
  completedOrders: 34,
  responseTime: 'Replies in about 2 hours',
}

export const providerPackages = [
  {
    id: 'ppk-1',
    name: '60-minute tutorial',
    priceNaira: 6500,
    sessionMinutes: 60,
    active: true,
    ordersThisMonth: 6,
  },
  {
    id: 'ppk-2',
    name: 'Exam revision plan',
    priceNaira: 12000,
    deliveryDays: 4,
    active: true,
    ordersThisMonth: 3,
  },
  {
    id: 'ppk-3',
    name: 'Weekly tutoring — 4 sessions',
    priceNaira: 22000,
    sessionMinutes: 60,
    active: false,
    ordersThisMonth: 0,
  },
]

export const providerOrders: MarketplaceOrder[] = [
  {
    id: 'pord-1',
    reference: 'ORD-40210',
    vertical: 'services',
    title: '60-minute tutorial — linear algebra',
    counterparty: 'Chidi Nwosu',
    counterpartyHandle: 'chidin',
    amountNaira: 6500,
    feeNaira: 325,
    state: 'IN_ESCROW',
    placed: '12 Aug 2026',
    dueLabel: 'Session Thu 14 Aug, 17:00',
    history: [
      { state: 'REQUESTED', at: '11 Aug, 21:40' },
      { state: 'ACCEPTED', at: '11 Aug, 22:02' },
      { state: 'FUNDED', at: '12 Aug, 07:15' },
      { state: 'IN_ESCROW', at: '12 Aug, 07:15' },
    ],
  },
  {
    id: 'pord-2',
    reference: 'ORD-40155',
    vertical: 'services',
    title: 'Exam revision plan — thermodynamics',
    counterparty: 'Blessing Ade',
    counterpartyHandle: 'blessinga',
    amountNaira: 12000,
    feeNaira: 600,
    state: 'DELIVERED',
    placed: '9 Aug 2026',
    dueLabel: 'Awaiting buyer approval',
    history: [
      { state: 'REQUESTED', at: '8 Aug, 10:00' },
      { state: 'ACCEPTED', at: '8 Aug, 10:22' },
      { state: 'FUNDED', at: '8 Aug, 11:00' },
      { state: 'IN_ESCROW', at: '8 Aug, 11:00' },
      { state: 'IN_PROGRESS', at: '8 Aug, 14:30' },
      { state: 'DELIVERED', at: '11 Aug, 18:12' },
    ],
  },
  {
    id: 'pord-3',
    reference: 'ORD-39990',
    vertical: 'services',
    title: '60-minute tutorial — probability',
    counterparty: 'Kelechi Obi',
    counterpartyHandle: 'kelechio',
    amountNaira: 6500,
    feeNaira: 325,
    state: 'RELEASED',
    placed: '1 Aug 2026',
    dueLabel: 'Settled 8 Aug',
    history: [
      { state: 'REQUESTED', at: '31 Jul, 09:00' },
      { state: 'FUNDED', at: '31 Jul, 09:40' },
      { state: 'IN_ESCROW', at: '31 Jul, 09:40' },
      { state: 'DELIVERED', at: '1 Aug, 18:00' },
      { state: 'COMPLETED', at: '2 Aug, 08:00' },
      { state: 'RELEASED', at: '8 Aug, 00:00' },
    ],
  },
]

export const providerEarnings = {
  pendingNaira: 6500,
  escrowNaira: 18500,
  availableNaira: 24700,
  withdrawableNaira: 18200,
  feeRate: 0.05,
  refundWindowDays: 7,
}
